exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-medisign-js": () => import("./../../../src/pages/medisign.js" /* webpackChunkName: "component---src-pages-medisign-js" */),
  "component---src-pages-medsys-js": () => import("./../../../src/pages/medsys.js" /* webpackChunkName: "component---src-pages-medsys-js" */)
}

